import { NodeType } from 'prosemirror-model';
import { objectIncludes } from './object.js';
export function closest($pos, predicate) {
    let pos = -1;
    let node = null;
    for (let i = $pos.depth; i > 0; i--) {
        const dNode = $pos.node(i);
        if (predicate(dNode)) {
            pos = i > 0 ? $pos.before(i) : 0;
            node = dNode;
            break;
        }
        if (dNode.type.spec.isolating) {
            break;
        }
    }
    return { pos, node };
}
export function getNodeType(n, schema) {
    if (n instanceof NodeType) {
        return n;
    }
    const name = typeof n === 'string' ? n : n.name;
    return schema.nodes[name];
}
export function isNodeActive(state, typeOrName, attributes = {}) {
    const { from, to, empty } = state.selection;
    const type = typeOrName ? getNodeType(typeOrName, state.schema) : null;
    let nodeRanges = [];
    state.doc.nodesBetween(from, to, (node, pos) => {
        if (!node.isText) {
            const relativeFrom = Math.max(from, pos);
            const relativeTo = Math.min(to, pos + node.nodeSize);
            nodeRanges = [
                ...nodeRanges,
                {
                    node,
                    from: relativeFrom,
                    to: relativeTo,
                },
            ];
        }
    });
    if (empty) {
        return !!nodeRanges
            .filter((nodeRange) => {
            if (!type) {
                return true;
            }
            return type.name === nodeRange.node.type.name;
        })
            .find((nodeRange) => objectIncludes(nodeRange.node.attrs, attributes));
    }
    const selectionRange = to - from;
    const range = nodeRanges
        .filter((nodeRange) => {
        if (!type) {
            return true;
        }
        return type.name === nodeRange.node.type.name;
    })
        .filter((nodeRange) => objectIncludes(nodeRange.node.attrs, attributes))
        .reduce((sum, nodeRange) => {
        const size = nodeRange.to - nodeRange.from;
        return sum + size;
    }, 0);
    return range >= selectionRange;
}
//# sourceMappingURL=node.js.map